import React from "react";
import { StyledCol, StyledTable, StyledTableBody, StyledTableHead, StyledTableRow } from "../../styles/styledTable";
import { StyledBlockLabel, StyledFormBlock } from "../../styles/styledTabsForm";

const ExchangeDetailsFlowData = ({ flowData, t }) => {

  if (flowData.length === 0) {
    return <></>;
  }

  return (
    <StyledFormBlock className="exchange-history-details__block">
      <StyledBlockLabel>
        {t("history.details.content.flowData")}
      </StyledBlockLabel>
      <StyledTable size="14">
        <StyledTableHead col="2" className="exchange-history-details__head">
          <StyledCol>
            {t("history.details.content.key")}:
          </StyledCol>
          <StyledCol>
            {t("history.details.content.value")}:
          </StyledCol>
        </StyledTableHead>
        <StyledTableBody>
          {flowData && flowData.map((item, key) => (
            <StyledTableRow key={key} col="2" className="exchange-history-details__row">
              <StyledCol data-title={t("key")}>
                {item.name}
              </StyledCol>
              <StyledCol data-title={t("value")}>
                {item.value}
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledFormBlock>
  );
};

export default ExchangeDetailsFlowData;